var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"font-family":"DINCond","position":"absolute","top":"100px"}},[_vm._v(".")]),_vm._v(" "),_c('div',{ref:"canvas",staticClass:"canvas page3D",class:_vm.bgimgnumber == 1?'black':'gray'},[(_vm.loading)?_c('div',{staticClass:"loading3d"},[_vm._v(_vm._s(_vm.loadingNum)+"%")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67853c05","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail3D.vue
// module id = null
// module chunks = 